import React, { useEffect, useState, } from 'react';
import error404 from '../assets/img/error404.svg';
import { Link ,useNavigate} from 'react-router-dom';

interface ErrorProps {
    statusCode: number;
    errMessage?: string;
}

const Error404: React.FC<ErrorProps> = ({statusCode, errMessage}) => {

   const navigate=useNavigate();

    const goBack=()=>{
        navigate(-1);
    }

    return (
        <div className="text-center">
            <img src={error404} className='img-fluid vh-65'/>
            <h1 className='text-secondary'>Oops...</h1>
            <h3 className='text-base'>{errMessage || 'Page not found!'}</h3>
            <div className='text-light mb-6'>The page you are looking for doesn't exist or another error occurred</div>
            <button onClick={goBack}  className='btn btn-secondary px-6 rounded'>
            <span className="material-symbols-outlined fs-16 align-text-top">arrow_back_ios</span>
            Go Back
            </button>
        </div>
    );
};

export default Error404;
